import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Angular2TokenService } from 'angular2-token';

@Component({
  selector: 'main-navigation',
  templateUrl: './main-navigation.pug',
})
export class MainNavigationComponent {

  constructor(
    private tokenService: Angular2TokenService,
    private router: Router,
  ) {}

  clickedSignOut() {
    this.tokenService.signOut()
      .subscribe(() => {
        window.location.href = '/'
      })
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/main-navigation.ts